export default {
  token: localStorage.getItem("token") || "",
};
